// A login account can be managed from a DMS member or from a family member.
// The value is the path segment used by /web/login-account/{entity}/{id}.
export type LoginAccountEntity = 'member' | 'family-member';

export interface LoginAccountTarget {
	entity: LoginAccountEntity;
	id: string;
}

export interface LoginAccountDTO {
	userId?: string | null;
	familyMemberId?: string | null;
	activated: boolean;
	loginId: string | null;
	sharedWithKat: boolean;
	// Family member only
	notificationProgramApp?: boolean | null;
	pauseOrMoveWaiting?: number | null;
	endDateOfPauseEnrollment?: string | null;
}

export enum LoginIdUnavailableReason {
	PhoneEmpty = 'PHONE_EMPTY',
	LoginIdTaken = 'LOGIN_ID_TAKEN',
}

export enum LoginIdHitSystem {
	DMS = 'DMS',
	TWC = 'TWC',
	KAT = 'KAT',
}

export interface LoginIdCheckHitDTO {
	system: LoginIdHitSystem;
	userId: string | null;
	twcMemberId: number | null;
	// Unit of the holder, e.g. "TWC(IS)"; "FWC" for KAT
	branchName: string | null;
	name: string | null;
	phone: string | null;
}

export interface LoginAccountCheckDTO {
	defaultLoginId: string | null;
	loginIdAvailable: boolean;
	unavailableReason: LoginIdUnavailableReason | null;
	// Whether staff may link to the existing account holding defaultLoginId
	canLink: boolean;
	hits: LoginIdCheckHitDTO[];
}

export interface LoginIdCheckDTO {
	loginId: string;
	loginIdAvailable: boolean;
	unavailableReason: LoginIdUnavailableReason | null;
	hits: LoginIdCheckHitDTO[];
}

export interface ProgramAppSettingsRequest {
	notificationProgramApp: boolean;
	pauseOrMoveWaiting: number;
	endDateOfPauseEnrollment: string | null;
}
